import { IPreviewItem } from '@/types/main'
import PreviewTextContent from '@/components/main/PreviewTextContent'
import PreviewImage from '@/components/main/PreviewImage'

const PREVIEW_IMAGE_SECTIONS = ['MAIN', 'TRADE', 'FEED', 'SHOP'] as const
interface IMoPreviewItemProps {
  item: IPreviewItem
  index: number
}

const MoPreviewItem: React.FC<IMoPreviewItemProps> = ({ item, index }) => {
  const textContentProps = {
    title: item.title,
    heading: item.heading,
    description: item.description
  }

  return (
    <section key={index} className="mt-[68px] flex w-full flex-col">
      <div>
        <PreviewImage section={PREVIEW_IMAGE_SECTIONS[index]} />
      </div>
      <div>
        <PreviewTextContent {...textContentProps} />
      </div>
    </section>
  )
}

export default MoPreviewItem
